"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenAccountRequest = void 0;
var OpenAccountRequest = /** @class */ (function () {
    function OpenAccountRequest() {
    }
    return OpenAccountRequest;
}());
exports.OpenAccountRequest = OpenAccountRequest;
;
//# sourceMappingURL=openAccount.request.js.map